<template>
  <section>
    <template v-if="!loading && value">
      <UiButton
        v-if="isMdAndDown"
        icon-transparent
        class="mb-6 flex size-9 min-w-9 items-center justify-center"
        @click="goBack()"
      >
        <UiIcon name="chevron-down" class="size-4 rotate-90 text-icon-secondary" />
      </UiButton>
      <UiTitle severity="h2" class="mb-1">
        {{ value.title }}
      </UiTitle>
      <p v-if="value && !value.repertoire.length" class="font-semibold">
        похоже, здесь мероприятий пока не запланировано
      </p>
    </template>
    <template v-else>
      <VenueBaseInfoSkeleton />
    </template>
  </section>
</template>

<script setup lang="ts">
import type { Venue } from '@/5_entities/Venue'
import { useGoBack } from '@/6_shared/composables'
import { useBreakpoint } from '@/6_shared/lib'
import { UiTitle, UiButton, UiIcon } from '@/6_shared/ui'
import VenueBaseInfoSkeleton from './VenueBaseInfoSkeleton.vue'

type PropType = {
  value?: Venue
  loading?: boolean
}

withDefaults(defineProps<PropType>(), {
  loading: false,
  value: undefined
})
const { goBack } = useGoBack()

const {
  md: [_isMdAndUp, isMdAndDown]
} = useBreakpoint()
</script>
